import { useGetCommentsQuery } from './comment.api.slice';
import CommentsTimeline from '@/components/Comment/CommentsTimeline';
import NoComments from '@/components/Illustrations/NoComments';
import { Skeleton } from '@/components/ui/skeleton';

function PostCommentList({ postId }: { postId: string }) {
  const { data: comments, isLoading } = useGetCommentsQuery(postId);

  if (isLoading) {
    return (
      <div className="flex flex-col gap-3 ">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="flex gap-3" key={index}>
            <Skeleton className="rounded-full w-10 h-10" />
            <div className="flex flex-col gap-2">
              <div className="flex items-center space-x-2">
                <Skeleton className="h-4 max-w-[200px] w-[200px]" />
                <Skeleton className="h-4 max-w-[100px] w-[100px]" />
              </div>
              <div className="flex gap-1 flex-col">
                <Skeleton className="h-4 max-w-[500px] w-[500px]" />
                <Skeleton className="h-4 max-w-[500px] w-[500px]" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (comments?.length === 0) {
    return (
      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center border-[#B4B7C9] border-2 border-dashed rounded-lg">
        <NoComments />
        <h1 className="font-primary font-bold text-[28px] text-[#292929]">
          Comments Not Found!
        </h1>
        <p className="font-secondary font-normal text-[#454545]">
          your thoughts could lead the way
        </p>
      </div>
    );
  }

  return comments && <CommentsTimeline comments={comments} />;
}

export default PostCommentList;
